(function () {
  if (window.ssFirstOrderOfferBound) return;
  window.ssFirstOrderOfferBound = true;
  var PHONE = "(max-width: 767px)";
  var READY_CLASS = "ss-klaviyo-ready";
  function refreshEmptyRatings() {
    document.querySelectorAll(".rating-with-text:has(.first-order-offer) .rating").forEach(function (rating) {
      rating.toggleAttribute("data-ss-empty-rating",
        rating.childElementCount === 0 && rating.textContent.trim() === "");
    });
  }
  function watchEmptyRatings() {
    refreshEmptyRatings();
    // Price fragments are replaced on variant changes. Observe content, not our own
    // marker writes; query current badges so detached fragments retain no observer state.
    new MutationObserver(refreshEmptyRatings).observe(document.body, {
      childList: true, subtree: true, characterData: true
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchEmptyRatings, { once: true });
  } else {
    watchEmptyRatings();
  }
  // Reveal the link only once klaviyo.js has loaded. Measured 2026-09-07: on load Klaviyo
  // keeps window._klOnsite an Array but attaches its methods to it (openForm, identify,
  // track…); when the script is blocked — uBlock, Brave Shields, Firefox strict tracking
  // protection — the queue stays a bare empty array for good, and a link that pushed onto
  // it would be a control that opens nothing. Polled rather than hooked, because Klaviyo
  // fires no "loaded" event. Every 250ms for the first 30s, then every 5s for as long as
  // the page lives — a consent banner or a script-delay app can land klaviyo.js late, and
  // a poll that had given up would hide the link for the whole visit. The failure
  // direction is a HIDDEN link, never a dead one — which also
  // means a Klaviyo runtime change that stops attaching openForm would hide the link
  // silently; the browser check after every upload must see the link, not just the code.
  var tries = 0;
  (function watch() {
    var queue = window._klOnsite;
    if (queue && typeof queue.openForm === "function") {
      document.documentElement.classList.add(READY_CLASS);
      return;
    }
    setTimeout(watch, ++tries < 120 ? 250 : 5000);
  })();
  document.addEventListener("click", function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest(".first-order-offer") : null;
    if (!button) return;
    var onPhone = window.matchMedia ? window.matchMedia(PHONE).matches : false;
    var formId = onPhone ? button.dataset.offerFormMobile : button.dataset.offerFormDesktop;
    // Added when the styles moved OUT of this snippet (SMR-049). While `display: none` and the
    // ready-class reveal shipped in the same bytes as the button, a visible button PROVED the
    // queue was loaded. Now the stylesheet is a separate request: if it fails, or the snippet
    // lands on a theme that lacks the asset, the button paints on every product page from the
    // first render and this push would throw on an undefined queue and open nothing. Re-assert
    // here the invariant the CSS used to carry.
    var queue = window._klOnsite;
    if (!queue || typeof queue.openForm !== "function") return;
    queue.push(["openForm", formId]);
  });
})();
